import {UserRole} from '../types/control';

export function hasAuthority(role: UserRole, requiredRole: UserRole) {
    if (role == null) {
        return false;
    }

    if (role === 'developer') {
        return true;
    }

    if (role === 'service') {
        return requiredRole === 'service' || requiredRole === 'admin' || requiredRole === 'user' || requiredRole === 'default';
    }

    if (role === 'admin') {
        return requiredRole === 'admin' || requiredRole === 'user' || requiredRole === 'default';
    }

    if (role === 'user') {
        return requiredRole === 'default' || requiredRole === 'user';
    }

    return requiredRole === 'default';
}
